import React from 'react'
import { useTranslation } from 'react-i18next'
import { useP2POffer } from 'pages/P2PView/hooks/useP2POffer'
import { buyerCryptoAmountLessP2PFee, getDAOAmountFee } from 'app-view/lib/utils'
import { Matched } from '../common/Matched'

export const SellMatchedAltOffer = () => {
  const { t } = useTranslation(['p2p'])
  const [{ offer }] = useP2POffer()

  return (
    <>
      <Matched
        secondary
        text={t('sell_matched_alt_offer', {
          buyer: offer.buyerLabel,
          amount: buyerCryptoAmountLessP2PFee(offer.amount),
          cryptoFee: getDAOAmountFee(offer.amount),
        })}
      />
    </>
  )
}
